import { GuardedDeletionService, SpeciesGroupService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpeciesGroupCreateDto,
  SpeciesGroupDto,
  SpeciesGroupExcelDownloadDto,
  SpeciesGroupUpdateDto,
} from '../proxy/general/dtos/species-group';
import { SPECIESGROUP_CONFIG, SPECIESGROUP_FIELDS } from './species-group.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-species-group',
  imports: [
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, SpeciesGroupService, ConfirmationService],
  templateUrl: './species-group.html',
  styleUrl: './species-group.scss',
})
export class SpeciesGroup extends BaseHierarchicalCrudComponent<
  SpeciesGroupDto,
  SpeciesGroupCreateDto,
  SpeciesGroupUpdateDto,
  SpeciesGroupExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(SpeciesGroupService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('SpeciesGroup', ids),
  };
  config = SPECIESGROUP_CONFIG;
  fields = SPECIESGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpeciesGroupDto): SpeciesGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      density: data.density,
      sapWoodMaterialId: data.sapWoodMaterialId,
      finalProductId: data.finalProductId,
      standardHumidityPercentage: data.standardHumidityPercentage,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpeciesGroup';
  }
}
